import type { GlobalToken } from 'antd';
import { LabResultState } from '../generated/openapi/befunde-api';

export const translateLabResultState = (value: LabResultState) => {
  switch (value) {
    case LabResultState.InProgress:
      return 'Befund in Arbeit';
    case LabResultState.PartialResult:
      return 'Teilbefund';
    case LabResultState.EndResult:
      return 'Endergebnis';
    case LabResultState.OrderReceived:
      return 'Auftrag empfangen';
    case LabResultState.SpecimenReceived:
      return 'Probe empfangen';
  }
};

export const labResultStateColor = (token: GlobalToken, labResultStatus: LabResultState) => {
  switch (labResultStatus) {
    case 'END_RESULT':
      return token.green5;
    case 'IN_PROGRESS':
      return token.blue3;
    case 'PARTIAL_RESULT':
      return token.blue3;
    case 'ORDER_RECEIVED':
      return token.orange3;
    case 'SPECIMEN_RECEIVED':
      return token.orange3;
  }
};
